import React from "react";

/** Recent imports history table shown at the bottom of every tab. */
export const ImportHistoryTable = ({ history }) => {
  if (!history?.length) return null;
  return (
    <div className="mt-10">
      <h2 className="font-heading text-lg font-bold tracking-tight text-slate-900 mb-3">
        Recent imports
      </h2>
      <div className="overflow-x-auto rounded-md border border-slate-200">
        <table className="w-full min-w-[540px] text-sm">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">When</th>
              <th className="px-4 py-2.5 text-left text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">By</th>
              <th className="px-4 py-2.5 text-right text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">Added</th>
              <th className="px-4 py-2.5 text-right text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">Updated</th>
              <th className="px-4 py-2.5 text-right text-[10px] font-bold uppercase tracking-[0.15em] text-slate-500">Missing</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h) => (
              <tr key={h.timestamp || `${h.actor}-${h.added}-${h.updated}`} className="border-t border-slate-200">
                <td className="px-4 py-2 font-mono text-xs text-slate-600">{h.timestamp?.slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-2 text-slate-800">{h.actor}</td>
                <td className="px-4 py-2 text-right font-mono text-emerald-700 font-bold">{h.added}</td>
                <td className="px-4 py-2 text-right font-mono text-nmi-700 font-bold">{h.updated}</td>
                <td className="px-4 py-2 text-right font-mono text-amber-700 font-bold">{h.flagged_missing}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
